import { useEffect, useMemo, useState } from 'react';
import { fetchRosterFileHistoryEvents } from '../api/rosterFileApi';

export default function useRosterFileHistoryEvents({
  handleId,
  scope = 'cluster',
  enabled = false,
  rosterDatasetRevision = 0,
}) {
  const [eventsLoading, setEventsLoading] = useState(false);
  const [eventsError, setEventsError] = useState(null);
  const [events, setEvents] = useState([]);

  const visibleEvents = useMemo(
    () => (Array.isArray(events) ? events.filter((e) => e?.redacted !== true) : []),
    [events],
  );

  useEffect(() => {
    if (!enabled) {
      setEvents([]);
      setEventsError(null);
      setEventsLoading(false);
      return;
    }
    const hid = Number(handleId);
    if (!Number.isInteger(hid) || hid < 1) {
      setEvents([]);
      setEventsError(null);
      return;
    }

    let cancelled = false;
    const load = async () => {
      setEventsLoading(true);
      setEventsError(null);
      try {
        const data = await fetchRosterFileHistoryEvents(hid, { scope });
        if (cancelled) return;
        if (!data?.ok) {
          setEvents([]);
          setEventsError(data?.error || 'Error loading events.');
          return;
        }
        setEvents(Array.isArray(data.events) ? data.events : []);
      } catch (e) {
        if (cancelled) return;
        setEvents([]);
        setEventsError('Error loading events.');
      } finally {
        if (!cancelled) setEventsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [enabled, handleId, scope, rosterDatasetRevision]);

  return { eventsLoading, eventsError, visibleEvents };
}
